import React from 'react'
import { Label } from '@/components/ui/label'
import { COUNT_OPTIONS } from '../constants/guide-limits'
import { CountComboboxInput } from './count-combobox-input'
import { FieldMessage } from './field-message'

type CountFieldProps = {
  heading: string
  label: string
  inputId: string
  value: string
  onChange: (value: string) => void
  message: string | null
}

/** One count section (columns or rows): heading, label, combobox and its message line. */
export const CountField: React.FC<CountFieldProps> = ({
  heading,
  label,
  inputId,
  value,
  onChange,
  message,
}) => {
  return (
    <section className="space-y-3">
      <h3 className="text-sm leading-5 font-medium text-[var(--base-muted-foreground,#737373)]">
        {heading}
      </h3>
      <div className="space-y-2">
        <Label
          htmlFor={inputId}
          className="text-sm leading-[14px] font-medium text-[var(--base-foreground,#0A0A0A)]"
        >
          {label}
        </Label>
        <CountComboboxInput
          id={inputId}
          value={value}
          onChange={onChange}
          placeholder=""
          error={message != null}
          options={COUNT_OPTIONS}
        />
        <FieldMessage message={message} />
      </div>
    </section>
  )
}
